// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/images/icons/calendar-alt.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/images/icons/users-alt.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:root {
  --sebrae-black: #000000;
  --sebrae-black-lighter: #282828;
  --sebrae-blue: #005eb8;
  --sebrae-white: #ffffff;
  --sebrae-white-2: #f5f5f5;
  --sebrae-white-3: #f0f6fe;
  --sebrae-white-4: #e2e6e8;
  --sebrae-white-5: #fafafa;
  --sebrae-dark-purple: #994599;
  --sebrae-purple-2: #9747ff;
  --sebrae-lilac: #9285f9;
  --sebrae-purple: #CD5BE8;
  --sebrae-pink: #C408A4;
  --sebrae-light-pink: #FEE7FA;
  --sebrae-light-blue: #5c8fd6;
  --sebrae-light-blue2: #6ebeff;
  --sebrae-light-blue3: #cfe2fc;
  --sebrae-blue-2: #0f438a;
  --sebrae-blue-3: #0024a9;
  --sebrae-blue-4: #0e778b;
  --sebrae-blue-5: #094f5d;
  --sebrae-blue-6: #2e5de6;
  --sebrae-blue-7: #006bff;
  --sebrae-blue-pdf-section: #318FFF;
  --sebrae-blue-pdf-title: #1D4CDD;
  --sebrae-dark-blue: #142e52;
  --sebrae-dark-blue-2: #0a1729;
  --sebrae-cyan: #14adcc;
  --sebrae-gray: #243342;
  --sebrae-dark-gray: #181a1b;
  --sebrae-light-gray: #f5f7fa;
  --sebrae-dark-gray2: #617385;
  --sebrae-dark-gray3: #394d60;
  --sebrae-light-gray2: #8b99a7;
  --sebrae-light-gray3: #d9d9d9;
  --sebrae-light-gray4: #e0e5eb;
  --sebrae-light-gray5: #b6bfc8;
  --sebrae-red: #bf303c;
  --sebrae-red-2: #b22400;
  --sebrae-red-3: #F4455A;
  --sebrae-green: #00662a;
  --sebrae-green-1: #7da29e;
  --sebrae-dark-green: #196159;
  --sebrae-dark-green2: #547a1f;
  --sebrae-dark-green3: #385214;
  --sebrae-light-green: #35b068;
  --sebrae-light-green2: #c2efd1;
  --sebrae-light-green3: #4a8761;
  --sebrae-light-green4: #e8f3d8;
  --sebrae-yellow: #ffbf40;
  --sebrae-yellow2: #ffbc33;
  --sebrae-dark-yellow: #8f6b24;
  --sebrae-light-yellow: #ffeecc;
  --sebrae-full-height: calc(100dvh - 56px);
}

body {
  font-family: Figtree, "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif !important;
  background-color: var(--sebrae-white);
  color: var(--sebrae-gray);
}
body * {
  box-sizing: border-box !important;
}

main {
  min-height: 100dvh;
  padding-top: 56px;
}
main.auth {
  min-height: calc(100dvh - 192px);
  --sebrae-full-height: calc(100dvh - 100px);
}
main.auth.has-onboarding {
  min-height: 100dvh;
}
@media screen and (min-width: 1024px) {
  main.auth {
    min-height: calc(100dvh - 110px);
    --sebrae-full-height: calc(100dvh - 190px);
  }
}
@media screen and (min-width: 1200px) {
  main.auth {
    padding-top: 60px;
  }
}

img {
  user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  max-width: 100%;
  object-fit: cover;
}

.container {
  margin: 0 auto;
  padding: 0 16px;
  width: 100%;
  max-width: 1264px !important;
}
@media screen and (min-width: 768px) {
  .container {
    padding: 0 24px;
  }
}

button,
a {
  cursor: pointer;
}
button:disabled,
a:disabled {
  opacity: 0.7;
  cursor: no-drop;
}

button {
  border: inherit;
  background: inherit;
  padding: inherit;
}

.link {
  background: transparent;
  padding: 0;
  color: inherit;
  font: inherit;
  margin: 0;
  display: inline-block;
  border: none;
  text-decoration: underline;
}

strong {
  font-weight: 700 !important;
}

.btn-without-style {
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  outline: none;
}

.mt-0 {
  margin-top: 0 !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.p-0 {
  padding: 0 !important;
}

.border-none {
  border: none !important;
}

.BaSe--helper-button-container button {
  padding: 0 !important;
}
.BaSe--input {
  margin-bottom: 20px;
}
.BaSe--input-label, .BaSe--input-sub-label {
  color: var(--sebrae-gray) !important;
  font-weight: 400 !important;
}
.BaSe--input-sub-label {
  font-size: 11px !important;
  font-style: normal !important;
}
.BaSe--input-input {
  width: 100% !important;
}
.BaSe--input-input::placeholder {
  color: var(--sebrae-light-gray2);
}
.BaSe--input-wrapper-label {
  z-index: auto !important;
}
.BaSe--input-label {
  font-size: 13px !important;
}
@media screen and (min-width: 375px) {
  .BaSe--input-label {
    font-size: 16px !important;
  }
}
.BaSe--input .BaSe--popover .BaSe--small1 {
  white-space: pre-wrap;
}
@media screen and (min-width: 768px) {
  .BaSe--input {
    max-width: 389px;
  }
}
.BaSe--popover-card div:first-child small {
  font-family: Campuni;
  font-size: 12px;
  color: var(--sebrae-blue-6);
  display: block;
  width: calc(100% - 10px);
  margin-bottom: 5px;
}
.BaSe--popover-card div:last-child {
  color: var(--sebrae-gray);
  font-size: 11px;
  line-height: 1.2;
}
.BaSe--popover-card div:last-child * {
  color: inherit !important;
}
.BaSe--popover-card div:last-child * .link {
  color: var(--sebrae-blue-7) !important;
}
@media screen and (min-width: 768px) {
  .BaSe--popover-card div:first-child small {
    font-size: 14px;
  }
  .BaSe--popover-card div:last-child {
    font-size: 13px;
  }
}
.BaSe--grid {
  gap: 24px !important;
}
.BaSe--button span {
  font-size: 13px;
}
@media screen and (min-width: 768px) {
  .BaSe--button span {
    font-size: 16px;
  }
}
.BaSe--datepicker-wrapper > div:first-of-type {
  right: 8px;
  background: transparent;
}
.BaSe--input-list-container .BaSe--icon-button {
  padding: 0;
  min-width: 30px;
  background: transparent !important;
}
.BaSe--input-list-container .BaSe--list {
  padding: 0;
  display: flex;
  flex-wrap: wrap;
}
.BaSe--input-list-container .BaSe--list-item {
  flex-direction: row-reverse;
  justify-content: flex-end;
  gap: 5px;
  border-radius: 100px;
  background: var(--sebrae-white-3);
  padding: 3px 12px;
  height: 32px;
}
.BaSe--input-list-container .BaSe--list-item:last-of-type {
  margin-bottom: 16px;
}
.BaSe--input-list-container .BaSe--list-item .BaSe--icon-button {
  min-width: 16px;
  width: 16px;
  height: 16px;
}
.BaSe--input-list-container .BaSe--list-item .BaSe--paragraph {
  font-size: 13px;
  line-height: 1;
  color: var(--sebrae-blue);
}
.BaSe--checkbox label {
  padding-bottom: 0 !important;
}

.d-none {
  display: none !important;
}

.wrapper-select {
  position: relative;
  width: 100%;
}
.wrapper-select .BaSe--select {
  margin-bottom: 20px;
}
.wrapper-select .BaSe--select > div:first-of-type {
  z-index: 2;
}
.wrapper-select .BaSe--select label {
  color: var(--sebrae-gray) !important;
  font-weight: 400 !important;
  font-size: 13px !important;
}
.wrapper-select .BaSe--select label:last-of-type {
  font-size: 11px !important;
  font-style: normal !important;
}
@media screen and (min-width: 375px) {
  .wrapper-select .BaSe--select label {
    font-size: 16px !important;
  }
}
.wrapper-select .BaSe--select-input {
  width: 100%;
  border: 1px solid var(--sebrae-light-gray2);
}
.wrapper-select .BaSe--select-input::placeholder {
  color: var(--sebrae-light-gray2);
}
.wrapper-select .BaSe--select-input:disabled {
  background: rgb(245, 247, 250) !important;
  color: rgb(182, 191, 200) !important;
}
.wrapper-select .BaSe--select ul {
  margin: 5px 0;
}
.wrapper-select .BaSe--select ul p {
  margin: 0 !important;
}
.wrapper-select .BaSe--select ul .BaSe--select-option {
  padding-right: 12px;
}
.wrapper-select .BaSe--select .BaSe--checkbox input + div {
  display: flex;
  align-items: center;
  justify-content: center;
}
.wrapper-select .BaSe--select .BaSe--checkbox label {
  color: var(--sebrae-gray) !important;
  font-weight: 400 !important;
  font-size: 13px !important;
}
@media screen and (min-width: 375px) {
  .wrapper-select .BaSe--select .BaSe--checkbox label {
    font-size: 16px !important;
  }
}
.wrapper-select.valid .BaSe--select-input {
  color: rgb(0, 102, 42) !important;
  border: 1px solid rgb(0, 102, 42);
}
.wrapper-select.invalid .BaSe--select-input {
  color: rgb(178, 36, 0) !important;
  border: 1px solid rgb(178, 36, 0);
}
.wrapper-select.has-value .BaSe--select-input {
  color: var(--sebrae-gray);
}
.wrapper-select.new-design .BaSe--select-input {
  height: 36px;
  border-color: var(--sebrae-light-gray5);
}
.wrapper-select.new-design label {
  color: var(--sebrae-dark-gray2) !important;
}
.wrapper-select.new-design .BaSe--select > div:last-of-type {
  border-color: var(--sebrae-light-gray5) !important;
}
@media screen and (min-width: 768px) {
  .wrapper-select.new-design .BaSe--select-input {
    height: 40px;
  }
}
.wrapper-select.with-icon .BaSe--select > div:last-of-type {
  border-color: var(--sebrae-light-gray5) !important;
}
.wrapper-select.with-icon .BaSe--select-input {
  padding-left: 32px;
  height: 36px;
  border-color: var(--sebrae-light-gray5);
}
.wrapper-select.with-icon label {
  color: var(--sebrae-dark-gray2) !important;
}
.wrapper-select.with-icon:before {
  content: "";
  position: absolute;
  left: 12px;
  top: 34px;
  width: 16px;
  height: 16px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 16px 16px;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 1;
}
.wrapper-select.with-icon.calendar:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.wrapper-select.with-icon.users:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@media screen and (min-width: 768px) {
  .wrapper-select.with-icon .BaSe--select-input {
    height: 40px;
  }
  .wrapper-select.with-icon:before {
    top: 37px;
  }
}
@media screen and (min-width: 768px) {
  .wrapper-select {
    max-width: 389px;
  }
}

.wrapper-input .BaSe--input-input {
  border: 1px solid var(--sebrae-light-gray2) !important;
  color: var(--sebrae-gray);
}
.wrapper-input.percentage-graph {
  position: relative;
  width: 100%;
  padding: 16px;
  height: 104px;
  display: flex;
  align-items: center;
  border-radius: 4px;
}
.wrapper-input.percentage-graph .BaSe--input {
  margin: 0;
}
.wrapper-input.percentage-graph .BaSe--input-label {
  font-size: 16px !important;
  font-weight: 700 !important;
  color: var(--sebrae-gray);
  margin-bottom: 5px;
}
.wrapper-input.percentage-graph .BaSe--input-input {
  width: 64px !important;
  padding: 1px 5px !important;
  text-align: center;
  color: var(--sebrae-gray) !important;
  margin-right: 16px;
}
.wrapper-input.percentage-graph .BaSe--input-input:disabled {
  background: rgb(245, 247, 250) !important;
  color: rgb(182, 191, 200) !important;
}
.wrapper-input.percentage-graph .BaSe--input-wrapper > div {
  display: none;
}
.wrapper-input.percentage-graph .progress-bar-container {
  position: absolute;
  z-index: 0;
  right: 16px;
  bottom: 34px;
  width: calc(100% - 112px);
}
.wrapper-input.valid .BaSe--input-input {
  color: rgb(0, 102, 42);
  border-color: rgb(0, 102, 42) !important;
}
.wrapper-input.invalid .BaSe--input-input {
  color: rgb(178, 36, 0);
  border-color: rgb(178, 36, 0) !important;
}

.inputs-blue .BaSe--input {
  color: var(--sebrae-blue);
}
.inputs-blue .BaSe--input label,
.inputs-blue .BaSe--input input {
  color: inherit !important;
}
.inputs-blue .BaSe--input input {
  border: 1px solid #8fb8ef !important;
  background: var(--sebrae-light-blue3) !important;
}

.input-error-message .error-message {
  display: none;
  margin-top: 5px;
  font-size: 13px;
  font-weight: 400;
}
.input-error-message.invalid {
  color: var(--sebrae-red);
}
.input-error-message.invalid label,
.input-error-message.invalid input {
  color: var(--sebrae-red) !important;
}
.input-error-message.invalid input {
  background: #f3d8da !important;
  border-color: var(--sebrae-red) !important;
}
.input-error-message.invalid .error-message {
  display: block;
}

.Toastify__toast {
  padding: 4px;
  margin-bottom: 0;
}
.Toastify__toast-body {
  align-items: flex-start;
}
.Toastify__toast-icon {
  width: 20px;
}
.Toastify__toast--success {
  background: #ebfaf0;
}
.Toastify__toast--success .toast-content h3 {
  color: var(--sebrae-green) !important;
}
.Toastify__toast--error {
  background: #ffeae5;
}
.Toastify__toast--error .toast-content h3 {
  color: var(--sebrae-red-2) !important;
}
@media screen and (min-width: 768px) {
  .Toastify__toast-container--top-right {
    top: 10px;
    right: 10px;
  }
}
.Toastify .toast-content h3 {
  color: var(--sebrae-dark-gray3);
  font-size: 14px;
  font-weight: 700;
  line-height: 1.2;
}
.Toastify .toast-content p {
  display: block;
  color: var(--sebrae-dark-gray3);
  font-size: 12px;
  font-weight: 400;
  margin: 3px 0 0;
  line-height: 1.3;
}

form input[disabled],
form select[disabled] {
  cursor: not-allowed !important;
}

.react-datepicker__month-wrapper {
  display: flex;
  gap: 12px;
}
.react-datepicker__month-text {
  width: 42px !important;
  height: 32px !important;
  border-radius: 4px !important;
}
.react-datepicker__month--disabled {
  opacity: 0.65;
  cursor: not-allowed;
  box-shadow: none !important;
}

.new-logo {
  width: 200px;
  object-fit: contain;
  margin-bottom: 50px;
  display: none;
}
@media screen and (min-width: 560px) {
  .new-logo {
    display: block;
  }
}
@media screen and (min-width: 1200px) {
  .new-logo {
    width: 265px;
    margin-bottom: 40px;
  }
}

.wrapper-container {
  padding: 40px 16px 16px 16px;
}
@media (min-width: 560px) {
  .wrapper-container {
    padding-top: 15px;
  }
}
@media (min-width: 1024px) {
  .wrapper-container {
    padding-left: 30px;
    padding-right: 30px;
  }
}
@media (min-width: 1200px) {
  .wrapper-container {
    padding-left: 40px;
    padding-right: 40px;
    padding-bottom: 50px;
  }
}

.slick-dots li {
  margin: 0 3px;
  width: 6px;
  height: 6px;
}
.slick-dots li button {
  background-color: var(--sebrae-light-gray3);
  border-radius: 100%;
  opacity: 1;
  width: 6px;
  height: 6px;
  transition: 0.3s;
  font-size: 1px;
  padding: 0;
}
.slick-dots li button:before {
  content: none;
}
.slick-dots li.slick-active button {
  background-color: var(--sebrae-blue);
}
@media screen and (min-width: 768px) {
  .slick-dots li {
    width: 10px;
    height: 10px;
    margin: 0 4px;
  }
  .slick-dots li button {
    width: 10px;
    height: 10px;
  }
}

.minimal-scrollbar {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.4) transparent;
}
.minimal-scrollbar::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
.minimal-scrollbar::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.4);
  border-radius: 3px;
}
.minimal-scrollbar::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 3px;
}
.minimal-scrollbar::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.9);
}

.btn-white-outline {
  width: auto;
  height: 40px;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  font-size: 13px;
  font-weight: 700;
  color: var(--sebrae-blue-6);
  border: 1px solid var(--sebrae-blue-6);
  border-radius: 4px;
  transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);
  padding: 8px 12px;
}
.btn-white-outline:disabled {
  cursor: not-allowed;
  background-color: rgb(224, 229, 235);
  border: none;
  color: rgba(16, 16, 16, 0.3);
}
@media screen and (min-width: 768px) {
  .btn-white-outline {
    font-size: 16px;
  }
}
@media screen and (min-width: 1025px) {
  .btn-white-outline:hover {
    background-color: rgba(102, 180, 255, 0.2);
  }
}

.text-center {
  text-align: center !important;
}
.text-left {
  text-align: left !important;
}
.text-right {
  text-align: right !important;
}
.text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.text-muted {
  font-size: 13px;
  font-style: italic;
  color: var(--sebrae-gray);
}
.text-muted .blue {
  color: var(--sebrae-blue-6);
}

.wrapper-button-fixed {
  position: sticky;
  bottom: 0;
  z-index: 5;
  width: 100%;
  padding: 16px;
  border-radius: 12px 12px 0 0;
  background: var(--sebrae-white);
  box-shadow: 0 -2px 6px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
}
.wrapper-button-fixed p {
  color: var(--sebrae-black);
  font-size: 11px;
  margin-bottom: 8px;
}
.wrapper-button-fixed .BaSe--button span {
  font-size: 14px;
}
@media screen and (min-width: 375px) {
  .wrapper-button-fixed p {
    font-size: 13px;
  }
  .wrapper-button-fixed .BaSe--button span {
    font-size: 16px;
  }
}
@media screen and (min-width: 768px) {
  .wrapper-button-fixed .BaSe--button {
    max-width: 343px;
    height: 48px;
    margin: 0 auto;
  }
}

.watch-progress-bar {
  position: relative;
  width: 100%;
  margin-top: 50px;
}
.watch-progress-bar__count {
  position: relative;
  transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);
  margin-bottom: 6px;
  color: var(--sebrae-blue-6);
  font-size: 13px;
  font-weight: 700;
  line-height: 1.2;
  display: inline-block;
}
.watch-progress-bar__bar {
  border-radius: 4px;
  background: var(--sebrae-light-gray3);
  overflow: hidden;
  width: 100%;
  height: 24px;
  margin-bottom: 4px;
  display: flex;
  transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);
}
.watch-progress-bar__bar--item {
  height: 100%;
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}
.watch-progress-bar__limits {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: var(--sebrae-light-gray2);
  font-size: 13px;
}
.watch-progress-bar__text {
  color: var(--sebrae-dark-gray);
  font-size: 11px;
  text-align: center;
  margin-top: 8px;
  transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);
}
.watch-progress-bar.invalid .watch-progress-bar__bar {
  border: 1px solid var(--sebrae-red);
}
.watch-progress-bar.invalid .watch-progress-bar__text, .watch-progress-bar.invalid .watch-progress-bar__count {
  color: var(--sebrae-red);
}
@media screen and (min-width: 1280px) {
  .watch-progress-bar__count, .watch-progress-bar__limits {
    font-size: 16px;
  }
}

.driver-popover {
  max-width: 354px !important;
  font-size: 16px !important;
  border: 2px solid var(--sebrae-light-blue3);
  border-radius: 4px !important;
  padding: 16px;
  background-color: var(--sebrae-white) !important;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}
.driver-popover-title {
  height: auto;
  padding-bottom: 14px;
  background: transparent;
  font-size: 19px;
  box-shadow: none;
  color: var(-sebrae-gray);
}
.driver-popover-title::after {
  content: "";
  position: absolute;
  left: -16px;
  right: -16px;
  bottom: 0;
  height: 1px;
  background-color: var(--sebrae-light-gray4);
}
.driver-popover-next-btn, .driver-popover-prev-btn {
  display: flex;
  align-items: center !important;
  justify-content: center !important;
  font-size: 13px !important;
  padding: 7px 12px !important;
  min-height: 32px !important;
  min-width: 71px !important;
  border-radius: 4px !important;
  border: 1px solid var(--sebrae-blue) !important;
  color: var(--sebrae-blue) !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2) !important;
}
.driver-popover-prev-btn {
  padding-right: 11px !important;
}
.driver-popover-description {
  font-size: 16px;
  font-weight: 400;
  color: var(--sebrae-gray);
  margin-top: 20px !important;
}
.driver-popover-footer {
  margin-top: 20px !important;
}

.d-flex {
  display: flex !important;
}

.d-block {
  display: block !important;
}

.d-inline-block {
  display: inline-block !important;
}

.align-items-center {
  align-items: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.quill {
  position: relative;
  width: 100%;
  background-color: #F9F9F9;
  border-radius: 4px !important;
}
.quill__small-text {
  color: var(--sebrae-light-gray2);
  font-size: 11px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
}
.quill__small-text.error {
  color: var(--sebrae-red);
}

.ql-toolbar.ql-snow {
  border: none !important;
  border-bottom: 1px solid var(--sebrae-light-gray2) !important;
  display: flex;
  align-items: center !important;
  justify-content: space-between !important;
  padding: 8px 16px !important;
}
.ql-toolbar.ql-snow .ql-formats {
  margin: 0 !important;
}
.ql-toolbar.ql-snow .ql-formats:first-of-type {
  flex: 1 1 !important;
}

.ql-container.ql-snow {
  border: none !important;
}

.ql-editor {
  font-family: "Figtree" !important;
  font-size: 16px !important;
  -webkit-font-smoothing: antialiased !important;
  color: var(--sebrae-gray) !important;
  height: 211px !important;
  max-height: 211px !important;
}
.ql-editor.ql-blank::before {
  color: var(--sebrae-light-gray2) !important;
  font-family: inherit;
  font-weight: 400 !important;
  font-style: normal !important;
  font-size: inherit !important;
}
.ql-editor .ql-size-small {
  font-size: 0.75em !important;
}
.ql-editor .ql-size-large {
  font-size: 1.5em !important;
}
.ql-editor em {
  font-style: italic !important;
}
.ql-editor strong {
  font-size: inherit !important;
}
.ql-editor * {
  font-family: inherit !important;
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before {
  content: "Normal" !important; /* valor default (false) */
}

/* Itens do dropdown */
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: "Normal" !important; /* default também */
}

/* Pequeno */
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
  content: "Pequeno" !important;
}

/* Grande */
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
  content: "Grande" !important;
}

@keyframes slideOpacityInLeftToRight {
  from {
    transform: translateX(-100%);
    opacity: 0;
  }
  to {
    transform: translateX(0%);
    opacity: 1;
  }
}
@keyframes slideInLeftToRight {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0%);
  }
}
@keyframes slideOutRightToLeft {
  from {
    transform: translateX(0%);
  }
  to {
    transform: translateX(-100%);
  }
}`, "",{"version":3,"sources":["webpack://./src/index.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,uBAAA;EACA,+BAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,6BAAA;EACA,0BAAA;EACA,uBAAA;EACA,wBAAA;EACA,sBAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;EACA,6BAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,kCAAA;EACA,gCAAA;EACA,2BAAA;EACA,6BAAA;EACA,sBAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,yBAAA;EACA,4BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,8BAAA;EACA,wBAAA;EACA,yBAAA;EACA,6BAAA;EACA,8BAAA;EACA,yCAAA;AAEF;;AACA;EACE,4FAAA;EAEA,qCAAA;EACA,yBAAA;AACF;AACE;EACE,iCAAA;AACJ;;AAEA;EACE,kBAAA;EACA,iBAAA;AACF;AACE;EACE,gCAAA;EACA,0CAAA;AACJ;AACI;EACE,kBAAA;AACN;AAEI;EARF;IASI,gCAAA;IACA,0CAAA;EACJ;AACF;AAAI;EAZF;IAaI,iBAAA;EAGJ;AACF;;AAAA;EACE,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;AAGF;;AADA;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,4BAAA;AAIF;AAFE;EANF;IAOI,eAAA;EAKF;AACF;;AAHA;;EAEE,eAAA;AAMF;AAJE;;EACE,YAAA;EACA,eAAA;AAOJ;;AAJA;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;AAOF;;AALA;EACE,uBAAA;EACA,UAAA;EACA,cAAA;EACA,aAAA;EACA,SAAA;EACA,qBAAA;EACA,YAAA;EACA,0BAAA;AAQF;;AANA;EACE,2BAAA;AASF;;AAPA;EACE,YAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;AAUF;;AARA;EACE,wBAAA;AAWF;;AATA;EACE,2BAAA;AAYF;;AAVA;EACE,qBAAA;AAaF;;AAXA;EACE,uBAAA;AAcF;;AAVI;EACE,qBAAA;AAaN;AAVE;EACE,mBAAA;AAYJ;AAVI;EAEE,oCAAA;EACA,2BAAA;AAWN;AATI;EAEI,0BAAA;EACA,6BAAA;AAUR;AAPI;EACE,sBAAA;AASN;AAPM;EACE,gCAAA;AASR;AANI;EACE,wBAAA;AAQN;AANI;EACE,0BAAA;AAQN;AANM;EAHF;IAII,0BAAA;EASN;AACF;AANM;EACE,qBAAA;AAQR;AAJI;EArCF;IAsCI,gBAAA;EAOJ;AACF;AAHM;EAEI,oBAAA;EACA,eAAA;EAEF,2BAAA;EACA,cAAA;EACA,wBAAA;EACA,kBAAA;AAGR;AAAI;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;AAEN;AAAM;EACE,yBAAA;AAER;AAAQ;EACE,sCAAA;AAEV;AAGI;EACE;IACE,eAAA;EADN;EAGI;IACE,eAAA;EADN;AACF;AAIE;EACE,oBAAA;AAFJ;AAKI;EACE,eAAA;AAHN;AAKM;EAHF;IAII,eAAA;EAFN;AACF;AAOM;EACE,UAAA;EACA,uBAAA;AALR;AAUI;EACE,UAAA;EACA,eAAA;EACA,kCAAA;AARN;AAUI;EACE,UAAA;EACA,aAAA;EACA,eAAA;AARN;AAUM;EACE,2BAAA;EACA,yBAAA;EACA,QAAA;EACA,oBAAA;EACA,iCAAA;EACA,iBAAA;EACA,YAAA;AARR;AAUQ;EACE,mBAAA;AARV;AAWQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;AATV;AAWQ;EACE,eAAA;EACA,cAAA;EACA,yBAAA;AATV;AAeI;EACE,4BAAA;AAbN;;AAiBA;EACE,wBAAA;AAdF;;AAgBA;EACE,kBAAA;EACA,WAAA;AAbF;AAeE;EACE,mBAAA;AAbJ;AAeI;EACE,UAAA;AAbN;AAgBI;EACE,oCAAA;EACA,2BAAA;EACA,0BAAA;AAdN;AAgBM;EAEI,0BAAA;EACA,6BAAA;AAfV;AAkBM;EAXF;IAYI,0BAAA;EAfN;AACF;AAiBI;EACE,WAAA;EACA,2CAAA;AAfN;AAiBM;EACE,gCAAA;AAfR;AAiBM;EACE,yCAAA;EACA,oCAAA;AAfR;AAkBI;EACE,aAAA;AAhBN;AAkBM;EACE,oBAAA;AAhBR;AAkBM;EACE,mBAAA;AAhBR;AAoBM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAlBR;AAoBM;EACE,oCAAA;EACA,2BAAA;EACA,0BAAA;AAlBR;AAoBQ;EALF;IAMI,0BAAA;EAjBR;AACF;AAsBI;EACE,iCAAA;EACA,iCAAA;AApBN;AAwBI;EACE,iCAAA;EACA,iCAAA;AAtBN;AA0BI;EACE,yBAAA;AAxBN;AA4BI;EACE,YAAA;EACA,uCAAA;AA1BN;AA4BI;EACE,0CAAA;AA1BN;AA6BM;EACE,kDAAA;AA3BR;AA8BI;EACE;IACE,YAAA;EA5BN;AACF;AAiCM;EACE,kDAAA;AA/BR;AAkCI;EACE,kBAAA;EACA,YAAA;EACA,uCAAA;AAhCN;AAkCI;EACE,0CAAA;AAhCN;AAkCI;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EAEE,yDAAA;EACA,0BAAA;EACA,2BAAA;EACA,4BAAA;EAEF,UAAA;AAlCN;AAsCM;EACE,yDAAA;AApCR;AAwCM;EACE,yDAAA;AAtCR;AAyCI;EACE;IACE,YAAA;EAvCN;EAyCI;IACE,SAAA;EAvCN;AACF;AA0CE;EAtJF;IAuJI,gBAAA;EAvCF;AACF;;AA0CE;EACE,sDAAA;EACA,yBAAA;AAvCJ;AAyCE;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AAvCJ;AAyCI;EACE,SAAA;AAvCN;AAyCM;EAEI,0BAAA;EACA,2BAAA;EAEF,yBAAA;EACA,kBAAA;AAzCR;AA2CM;EACE,sBAAA;EACA,2BAAA;EACA,kBAAA;EACA,oCAAA;EACA,kBAAA;AAzCR;AA2CQ;EACE,yCAAA;EACA,oCAAA;AAzCV;AA6CQ;EACE,aAAA;AA3CV;AA+CI;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;AA7CN;AAiDI;EACE,sBAAA;EACA,wCAAA;AA/CN;AAmDI;EACE,sBAAA;EACA,wCAAA;AAjDN;;AAsDE;EACE,yBAAA;AAnDJ;AAqDI;;EAEE,yBAAA;AAnDN;AAqDI;EACE,oCAAA;EACA,gDAAA;AAnDN;;AAwDE;EACE,aAAA;EACA,eAAA;EAEE,eAAA;EACA,gBAAA;AAtDN;AAyDE;EACE,wBAAA;AAvDJ;AAyDI;;EAEE,mCAAA;AAvDN;AAyDI;EACE,8BAAA;EACA,0CAAA;AAvDN;AAyDI;EACE,cAAA;AAvDN;;AA4DE;EACE,YAAA;EACA,gBAAA;AAzDJ;AA2DI;EACE,uBAAA;AAzDN;AA2DI;EACE,WAAA;AAzDN;AA2DI;EACE,mBAAA;AAzDN;AA2DM;EACE,qCAAA;AAzDR;AA4DI;EACE,mBAAA;AA1DN;AA4DM;EACE,qCAAA;AA1DR;AA8DM;EADF;IAEI,SAAA;IACA,WAAA;EA3DN;AACF;AAgEI;EACE,+BAAA;EAEE,eAAA;EACA,gBAAA;EAEF,gBAAA;AAhEN;AAkEI;EACE,cAAA;EACA,+BAAA;EAEE,eAAA;EACA,gBAAA;EAEF,eAAA;EACA,gBAAA;AAlEN;;AAyEI;;EACE,8BAAA;AArEN;;AA0EE;EACE,aAAA;EACA,SAAA;AAvEJ;AAyEE;EACE,sBAAA;EACA,uBAAA;EACA,6BAAA;AAvEJ;AAyEE;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;AAvEJ;;AA0EA;EACE,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;AAvEF;AAyEE;EANF;IAOI,cAAA;EAtEF;AACF;AAwEE;EAVF;IAWI,YAAA;IACA,mBAAA;EArEF;AACF;;AAuEA;EACE,4BAAA;AApEF;AAsEE;EAHF;IAII,iBAAA;EAnEF;AACF;AAoEE;EANF;IAQM,kBAAA;IACA,mBAAA;EAlEJ;AACF;AAoEE;EAZF;IAcM,kBAAA;IACA,mBAAA;IACA,oBAAA;EAlEJ;AACF;;AAsEE;EACE,aAAA;EACA,UAAA;EACA,WAAA;AAnEJ;AAqEI;EACE,2CAAA;EACA,mBAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;AAnEN;AAqEM;EACE,aAAA;AAnER;AAuEM;EACE,oCAAA;AArER;AAyEI;EAzBF;IA0BI,WAAA;IACA,YAAA;IACA,aAAA;EAtEJ;EAwEI;IACE,WAAA;IACA,YAAA;EAtEN;AACF;;AA0EA;EACE,gBAAA;EACA,qBAAA;EACA,qDAAA;AAvEF;AAyEE;EACE,UAAA;EACA,WAAA;AAvEJ;AA0EE;EACE,oCAAA;EACA,kBAAA;AAxEJ;AA2EE;EACE,uBAAA;EACA,kBAAA;AAzEJ;AA4EE;EACE,oCAAA;AA1EJ;;AA6EA;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EAEE,eAAA;EACA,gBAAA;EAEF,2BAAA;EACA,sCAAA;EACA,kBAAA;EACA,kDAAA;EACA,iBAAA;AA5EF;AA8EE;EACE,mBAAA;EACA,oCAAA;EACA,YAAA;EACA,4BAAA;AA5EJ;AA+EE;EAzBF;IA0BI,eAAA;EA5EF;AACF;AA6EE;EACE;IACE,0CAAA;EA3EJ;AACF;;AA+EE;EACE,6BAAA;AA5EJ;AA8EE;EACE,2BAAA;AA5EJ;AA8EE;EACE,4BAAA;AA5EJ;AA8EE;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AA5EJ;AA8EE;EAEI,eAAA;EACA,kBAAA;EAEF,yBAAA;AA9EJ;AAgFI;EACE,2BAAA;AA9EN;;AAkFA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,4BAAA;EACA,+BAAA;EACA,2CAAA;EACA,kBAAA;AA/EF;AAiFE;EACE,0BAAA;EACA,eAAA;EACA,kBAAA;AA/EJ;AAkFI;EACE,eAAA;AAhFN;AAoFE;EACE;IACE,eAAA;EAlFJ;EAqFI;IACE,eAAA;EAnFN;AACF;AAsFE;EACE;IACE,gBAAA;IACA,YAAA;IACA,cAAA;EApFJ;AACF;;AAuFA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AApFF;AAsFE;EACE,kBAAA;EACA,kDAAA;EACA,kBAAA;EACA,2BAAA;EAEE,eAAA;EACA,gBAAA;EAEF,gBAAA;EACA,qBAAA;AAtFJ;AAwFE;EACE,kBAAA;EACA,qCAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,kDAAA;AAtFJ;AAwFI;EACE,YAAA;EAEE,eAAA;EACA,gBAAA;EAEF,aAAA;EACA,mBAAA;EACA,uBAAA;AAxFN;AA2FE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gCAAA;EACA,eAAA;AAzFJ;AA2FE;EACE,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,kDAAA;AAzFJ;AA8FM;EACE,mCAAA;AA5FR;AA8FM;EAEE,wBAAA;AA7FR;AAkGE;EACE;IAEE,eAAA;EAjGJ;AACF;;AAoGA;EACE,2BAAA;EACA,0BAAA;EACA,2CAAA;EACA,6BAAA;EACA,aAAA;EACA,gDAAA;EACA,yCAAA;AAjGF;AAmGE;EACE,YAAA;EACA,oBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;AAjGJ;AAmGI;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,2CAAA;AAjGN;AAoGE;EAEE,aAAA;EACA,8BAAA;EACA,kCAAA;EACA,0BAAA;EACA,4BAAA;EACA,2BAAA;EACA,0BAAA;EACA,6BAAA;EACA,+CAAA;EACA,oCAAA;EACA,mDAAA;AAnGJ;AAqGE;EACE,8BAAA;AAnGJ;AAqGE;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,2BAAA;AAnGJ;AAqGE;EACE,2BAAA;AAnGJ;;AAsGA;EACE,wBAAA;AAnGF;;AAqGA;EACE,yBAAA;AAlGF;;AAoGA;EACE,gCAAA;AAjGF;;AAmGA;EACE,8BAAA;AAhGF;;AAkGA;EACE,yCAAA;AA/FF;;AAiGA;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,6BAAA;AA9FF;AAgGE;EACE,gCAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;AA9FJ;AAgGI;EACE,wBAAA;AA9FN;;AAkGA;EACE,uBAAA;EACA,6DAAA;EACA,aAAA;EACA,8BAAA;EACA,yCAAA;EACA,4BAAA;AA/FF;AAiGE;EACE,oBAAA;AA/FJ;AAiGI;EACE,oBAAA;AA/FN;;AAmGA;EACE,uBAAA;AAhGF;;AAkGA;EAEI,iCAAA;EACA,0BAAA;EAEF,8CAAA;EACA,oCAAA;EACA,wBAAA;EACA,4BAAA;AAjGF;AAmGE;EACE,2CAAA;EAEE,oBAAA;EACA,2BAAA;EACA,6BAAA;EACA,6BAAA;AAlGN;AAqGE;EACE,4BAAA;AAnGJ;AAqGE;EACE,2BAAA;AAnGJ;AAqGE;EACE,6BAAA;AAnGJ;AAqGE;EACE,6BAAA;AAnGJ;AAqGE;EAEI,+BAAA;AApGN;;AAwGA;EACE,4BAAA,EAAA,0BAAA;AArGF;;AAuGA,sBAAA;AACA;EACE,4BAAA,EAAA,mBAAA;AApGF;;AAsGA,YAAA;AACA;;EAEE,6BAAA;AAnGF;;AAqGA,WAAA;AACA;;EAEE,4BAAA;AAlGF;;AAqGA;EACE;IACE,4BAAA;IACA,UAAA;EAlGF;EAoGA;IACE,yBAAA;IACA,UAAA;EAlGF;AACF;AAoGA;EACE;IACE,4BAAA;EAlGF;EAoGA;IACE,yBAAA;EAlGF;AACF;AAoGA;EACE;IACE,yBAAA;EAlGF;EAoGA;IACE,4BAAA;EAlGF;AACF","sourcesContent":[":root {\n  --sebrae-black: #000000;\n  --sebrae-black-lighter: #282828;\n  --sebrae-blue: #005eb8;\n  --sebrae-white: #ffffff;\n  --sebrae-white-2: #f5f5f5;\n  --sebrae-white-3: #f0f6fe;\n  --sebrae-white-4: #e2e6e8;\n  --sebrae-white-5: #fafafa;\n  --sebrae-dark-purple: #994599;\n  --sebrae-purple-2: #9747ff;\n  --sebrae-lilac: #9285f9;\n  --sebrae-purple: #CD5BE8;\n  --sebrae-pink: #C408A4;\n  --sebrae-light-pink: #FEE7FA;\n  --sebrae-light-blue: #5c8fd6;\n  --sebrae-light-blue2: #6ebeff;\n  --sebrae-light-blue3: #cfe2fc;\n  --sebrae-blue-2: #0f438a;\n  --sebrae-blue-3: #0024a9;\n  --sebrae-blue-4: #0e778b;\n  --sebrae-blue-5: #094f5d;\n  --sebrae-blue-6: #2e5de6;\n  --sebrae-blue-7: #006bff;\n  --sebrae-blue-pdf-section: #318FFF;\n  --sebrae-blue-pdf-title: #1D4CDD;\n  --sebrae-dark-blue: #142e52;\n  --sebrae-dark-blue-2: #0a1729;\n  --sebrae-cyan: #14adcc;\n  --sebrae-gray: #243342;\n  --sebrae-dark-gray: #181a1b;\n  --sebrae-light-gray: #f5f7fa;\n  --sebrae-dark-gray2: #617385;\n  --sebrae-dark-gray3: #394d60;\n  --sebrae-light-gray2: #8b99a7;\n  --sebrae-light-gray3: #d9d9d9;\n  --sebrae-light-gray4: #e0e5eb;\n  --sebrae-light-gray5: #b6bfc8;\n  --sebrae-red: #bf303c;\n  --sebrae-red-2: #b22400;\n  --sebrae-red-3: #F4455A;\n  --sebrae-green: #00662a;\n  --sebrae-green-1: #7da29e;\n  --sebrae-dark-green: #196159;\n  --sebrae-dark-green2: #547a1f;\n  --sebrae-dark-green3: #385214;\n  --sebrae-light-green: #35b068;\n  --sebrae-light-green2: #c2efd1;\n  --sebrae-light-green3: #4a8761;\n  --sebrae-light-green4: #e8f3d8;\n  --sebrae-yellow: #ffbf40;\n  --sebrae-yellow2: #ffbc33;\n  --sebrae-dark-yellow: #8f6b24;\n  --sebrae-light-yellow: #ffeecc;\n  --sebrae-full-height: calc(100dvh - 56px);\n}\n\nbody {\n  font-family: Figtree, \"Open Sans\", \"Helvetica Neue\", Helvetica, Arial,\n    sans-serif !important;\n  background-color: var(--sebrae-white);\n  color: var(--sebrae-gray);\n\n  * {\n    box-sizing: border-box !important;\n  }\n}\nmain {\n  min-height: 100dvh;\n  padding-top: 56px;\n\n  &.auth {\n    min-height: calc(100dvh - 192px);\n    --sebrae-full-height: calc(100dvh - 100px);\n\n    &.has-onboarding {\n      min-height: 100dvh;\n    }\n\n    @media screen and (min-width: 1024px) {\n      min-height: calc(100dvh - 110px);\n      --sebrae-full-height: calc(100dvh - 190px);\n    }\n    @media screen and (min-width: 1200px) {\n      padding-top: 60px;\n    }\n  }\n}\nimg {\n  user-drag: none;\n  user-select: none;\n  -moz-user-select: none;\n  -webkit-user-drag: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  max-width: 100%;\n  object-fit: cover;\n}\n.container {\n  margin: 0 auto;\n  padding: 0 16px;\n  width: 100%;\n  max-width: 1264px !important;\n\n  @media screen and (min-width: 768px) {\n    padding: 0 24px;\n  }\n}\nbutton,\na {\n  cursor: pointer;\n\n  &:disabled {\n    opacity: 0.7;\n    cursor: no-drop;\n  }\n}\nbutton {\n  border: inherit;\n  background: inherit;\n  padding: inherit;\n}\n.link {\n  background: transparent;\n  padding: 0;\n  color: inherit;\n  font: inherit;\n  margin: 0;\n  display: inline-block;\n  border: none;\n  text-decoration: underline;\n}\nstrong {\n  font-weight: 700 !important;\n}\n.btn-without-style {\n  border: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n  outline: none;\n}\n.mt-0 {\n  margin-top: 0 !important;\n}\n.mb-0 {\n  margin-bottom: 0 !important;\n}\n.p-0 {\n  padding: 0 !important;\n}\n.border-none {\n  border: none !important;\n}\n.BaSe {\n  &--helper-button-container {\n    button {\n      padding: 0 !important;\n    }\n  }\n  &--input {\n    margin-bottom: 20px;\n\n    &-label,\n    &-sub-label {\n      color: var(--sebrae-gray) !important;\n      font-weight: 400 !important;\n    }\n    &-sub-label {\n      font: {\n        size: 11px !important;\n        style: normal !important;\n      }\n    }\n    &-input {\n      width: 100% !important;\n\n      &::placeholder {\n        color: var(--sebrae-light-gray2);\n      }\n    }\n    &-wrapper-label {\n      z-index: auto !important;\n    }\n    &-label {\n      font-size: 13px !important;\n\n      @media screen and (min-width: 375px) {\n        font-size: 16px !important;\n      }\n    }\n    .BaSe--popover {\n      .BaSe--small1 {\n        white-space: pre-wrap;\n      }\n    }\n\n    @media screen and (min-width: 768px) {\n      max-width: 389px;\n    }\n  }\n  &--popover-card {\n    div:first-child {\n      small {\n        font: {\n          family: Campuni;\n          size: 12px;\n        }\n        color: var(--sebrae-blue-6);\n        display: block;\n        width: calc(100% - 10px);\n        margin-bottom: 5px;\n      }\n    }\n    div:last-child {\n      color: var(--sebrae-gray);\n      font-size: 11px;\n      line-height: 1.2;\n\n      * {\n        color: inherit !important;\n\n        .link {\n          color: var(--sebrae-blue-7) !important;\n        }\n      }\n    }\n\n    @media screen and (min-width: 768px) {\n      div:first-child small {\n        font-size: 14px;\n      }\n      div:last-child {\n        font-size: 13px;\n      }\n    }\n  }\n  &--grid {\n    gap: 24px !important;\n  }\n  &--button {\n    span {\n      font-size: 13px;\n\n      @media screen and (min-width: 768px) {\n        font-size: 16px;\n      }\n    }\n  }\n  &--datepicker {\n    &-wrapper {\n      > div:first-of-type {\n        right: 8px;\n        background: transparent;\n      }\n    }\n  }\n  &--input-list-container {\n    .BaSe--icon-button {\n      padding: 0;\n      min-width: 30px;\n      background: transparent !important;\n    }\n    .BaSe--list {\n      padding: 0;\n      display: flex;\n      flex-wrap: wrap;\n\n      &-item {\n        flex-direction: row-reverse;\n        justify-content: flex-end;\n        gap: 5px;\n        border-radius: 100px;\n        background: var(--sebrae-white-3);\n        padding: 3px 12px;\n        height: 32px;\n\n        &:last-of-type {\n          margin-bottom: 16px;\n        }\n\n        .BaSe--icon-button {\n          min-width: 16px;\n          width: 16px;\n          height: 16px;\n        }\n        .BaSe--paragraph {\n          font-size: 13px;\n          line-height: 1;\n          color: var(--sebrae-blue);\n        }\n      }\n    }\n  }\n  &--checkbox {\n    label {\n      padding-bottom: 0 !important;\n    }\n  }\n}\n.d-none {\n  display: none !important;\n}\n.wrapper-select {\n  position: relative;\n  width: 100%;\n\n  .BaSe--select {\n    margin-bottom: 20px;\n\n    > div:first-of-type {\n      z-index: 2;\n    }\n\n    label {\n      color: var(--sebrae-gray) !important;\n      font-weight: 400 !important;\n      font-size: 13px !important;\n\n      &:last-of-type {\n        font: {\n          size: 11px !important;\n          style: normal !important;\n        }\n      }\n      @media screen and (min-width: 375px) {\n        font-size: 16px !important;\n      }\n    }\n    &-input {\n      width: 100%;\n      border: 1px solid var(--sebrae-light-gray2);\n\n      &::placeholder {\n        color: var(--sebrae-light-gray2);\n      }\n      &:disabled {\n        background: rgb(245, 247, 250) !important;\n        color: rgb(182, 191, 200) !important;\n      }\n    }\n    ul {\n      margin: 5px 0;\n\n      p {\n        margin: 0 !important;\n      }\n      .BaSe--select-option {\n        padding-right: 12px;\n      }\n    }\n    .BaSe--checkbox {\n      input+div {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n      label {\n        color: var(--sebrae-gray) !important;\n        font-weight: 400 !important;\n        font-size: 13px !important;\n\n        @media screen and (min-width: 375px) {\n          font-size: 16px !important;\n        }\n      }\n    }\n  }\n  &.valid {\n    .BaSe--select-input {\n      color: rgb(0, 102, 42) !important;\n      border: 1px solid rgb(0, 102, 42);\n    }\n  }\n  &.invalid {\n    .BaSe--select-input {\n      color: rgb(178, 36, 0) !important;\n      border: 1px solid rgb(178, 36, 0);\n    }\n  }\n  &.has-value {\n    .BaSe--select-input {\n      color: var(--sebrae-gray);\n    }\n  }\n  &.new-design {\n    .BaSe--select-input {\n      height: 36px;\n      border-color: var(--sebrae-light-gray5);\n    }\n    label {\n      color: var(--sebrae-dark-gray2)!important;\n    }\n    .BaSe--select {\n      > div:last-of-type {\n        border-color: var(--sebrae-light-gray5)!important;\n      }\n    }\n    @media screen and (min-width: 768px) {\n      .BaSe--select-input {\n        height: 40px;\n      }\n    }\n  }\n  &.with-icon {\n    .BaSe--select {\n      > div:last-of-type {\n        border-color: var(--sebrae-light-gray5)!important;\n      }\n    }\n    .BaSe--select-input {\n      padding-left: 32px;\n      height: 36px;\n      border-color: var(--sebrae-light-gray5);\n    }\n    label {\n      color: var(--sebrae-dark-gray2)!important;\n    }\n    &:before {\n      content: '';\n      position: absolute;\n      left: 12px;\n      top: 34px;\n      width: 16px;\n      height: 16px;\n      background: {\n        image: url(\"./assets/images/icons/calendar-alt.png\");\n        size: 16px 16px;\n        position: center;\n        repeat: no-repeat;\n      };\n      z-index: 1;\n    }\n\n    &.calendar {\n      &:before {\n        background-image: url('./assets/images/icons/calendar-alt.png');\n      }\n    }\n    &.users {\n      &:before {\n        background-image: url('./assets/images/icons/users-alt.png');\n      }\n    }\n    @media screen and (min-width: 768px) {\n      .BaSe--select-input {\n        height: 40px;\n      }\n      &:before {\n        top: 37px;\n      }\n    }\n  }\n  @media screen and (min-width: 768px) {\n    max-width: 389px;\n  }\n}\n.wrapper-input {\n  .BaSe--input-input {\n    border: 1px solid var(--sebrae-light-gray2) !important;\n    color: var(--sebrae-gray);\n  }\n  &.percentage-graph {\n    position: relative;\n    width: 100%;\n    padding: 16px;\n    height: 104px;\n    display: flex;\n    align-items: center;\n    border-radius: 4px;\n\n    .BaSe--input {\n      margin: 0;\n\n      &-label {\n        font: {\n          size: 16px !important;\n          weight: 700 !important;\n        }\n        color: var(--sebrae-gray);\n        margin-bottom: 5px;\n      }\n      &-input {\n        width: 64px !important;\n        padding: 1px 5px !important;\n        text-align: center;\n        color: var(--sebrae-gray) !important;\n        margin-right: 16px;\n\n        &:disabled {\n          background: rgb(245, 247, 250) !important;\n          color: rgb(182, 191, 200) !important;\n        }\n      }\n      &-wrapper {\n        > div {\n          display: none;\n        }\n      }\n    }\n    .progress-bar-container {\n      position: absolute;\n      z-index: 0;\n      right: 16px;\n      bottom: 34px;\n      width: calc(100% - 112px);\n    }\n  }\n  &.valid {\n    .BaSe--input-input {\n      color: rgb(0, 102, 42);\n      border-color: rgb(0, 102, 42) !important;\n    }\n  }\n  &.invalid {\n    .BaSe--input-input {\n      color: rgb(178, 36, 0);\n      border-color: rgb(178, 36, 0) !important;\n    }\n  }\n}\n.inputs-blue {\n  .BaSe--input {\n    color: var(--sebrae-blue);\n\n    label,\n    input {\n      color: inherit !important;\n    }\n    input {\n      border: 1px solid #8fb8ef !important;\n      background: var(--sebrae-light-blue3) !important;\n    }\n  }\n}\n.input-error-message {\n  .error-message {\n    display: none;\n    margin-top: 5px;\n    font: {\n      size: 13px;\n      weight: 400;\n    }\n  }\n  &.invalid {\n    color: var(--sebrae-red);\n\n    label,\n    input {\n      color: var(--sebrae-red) !important;\n    }\n    input {\n      background: #f3d8da !important;\n      border-color: var(--sebrae-red) !important;\n    }\n    .error-message {\n      display: block;\n    }\n  }\n}\n.Toastify {\n  &__toast {\n    padding: 4px;\n    margin-bottom: 0;\n\n    &-body {\n      align-items: flex-start;\n    }\n    &-icon {\n      width: 20px;\n    }\n    &--success {\n      background: #ebfaf0;\n\n      .toast-content h3 {\n        color: var(--sebrae-green) !important;\n      }\n    }\n    &--error {\n      background: #ffeae5;\n\n      .toast-content h3 {\n        color: var(--sebrae-red-2) !important;\n      }\n    }\n    &-container--top-right {\n      @media screen and (min-width: 768px) {\n        top: 10px;\n        right: 10px;\n      }\n    }\n  }\n\n  .toast-content {\n    h3 {\n      color: var(--sebrae-dark-gray3);\n      font: {\n        size: 14px;\n        weight: 700;\n      }\n      line-height: 1.2;\n    }\n    p {\n      display: block;\n      color: var(--sebrae-dark-gray3);\n      font: {\n        size: 12px;\n        weight: 400;\n      }\n      margin: 3px 0 0;\n      line-height: 1.3;\n    }\n  }\n}\nform {\n  input,\n  select {\n    &[disabled] {\n      cursor: not-allowed !important;\n    }\n  }\n}\n.react-datepicker {\n  &__month-wrapper {\n    display: flex;\n    gap: 12px;\n  }\n  &__month-text {\n    width: 42px !important;\n    height: 32px !important;\n    border-radius: 4px !important;\n  }\n  &__month--disabled {\n    opacity: 0.65;\n    cursor: not-allowed;\n    box-shadow: none !important;\n  }\n}\n.new-logo {\n  width: 200px;\n  object-fit: contain;\n  margin-bottom: 50px;\n  display: none;\n\n  @media screen and (min-width: 560px) {\n    display: block;\n  }\n\n  @media screen and (min-width: 1200px) {\n    width: 265px;\n    margin-bottom: 40px;\n  }\n}\n.wrapper-container {\n  padding: 40px 16px 16px 16px;\n\n  @media (min-width: 560px) {\n    padding-top: 15px;\n  }\n  @media (min-width: 1024px) {\n    padding: {\n      left: 30px;\n      right: 30px;\n    }\n  }\n  @media (min-width: 1200px) {\n    padding: {\n      left: 40px;\n      right: 40px;\n      bottom: 50px;\n    }\n  }\n}\n.slick-dots {\n  li {\n    margin: 0 3px;\n    width: 6px;\n    height: 6px;\n\n    button {\n      background-color: var(--sebrae-light-gray3);\n      border-radius: 100%;\n      opacity: 1;\n      width: 6px;\n      height: 6px;\n      transition: 0.3s;\n      font-size: 1px;\n      padding: 0;\n\n      &:before {\n        content: none;\n      }\n    }\n    &.slick-active {\n      button {\n        background-color: var(--sebrae-blue);\n      }\n    }\n\n    @media screen and (min-width: 768px) {\n      width: 10px;\n      height: 10px;\n      margin: 0 4px;\n\n      button {\n        width: 10px;\n        height: 10px;\n      }\n    }\n  }\n}\n.minimal-scrollbar {\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(#ffffff, 0.4) transparent;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(#ffffff, 0.4);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: rgba(#ffffff, 0.9);\n  }\n}\n.btn-white-outline {\n  width: auto;\n  height: 40px;\n  background: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  font: {\n    size: 13px;\n    weight: 700;\n  }\n  color: var(--sebrae-blue-6);\n  border: 1px solid var(--sebrae-blue-6);\n  border-radius: 4px;\n  transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);\n  padding: 8px 12px;\n\n  &:disabled {\n    cursor: not-allowed;\n    background-color: rgb(224, 229, 235);\n    border: none;\n    color: rgba(16, 16, 16, 0.3);\n  }\n\n  @media screen and (min-width: 768px) {\n    font-size: 16px;\n  }\n  @media screen and (min-width: 1025px) {\n    &:hover {\n      background-color: rgba(102, 180, 255, 0.2);\n    }\n  }\n}\n.text {\n  &-center {\n    text-align: center !important;\n  }\n  &-left {\n    text-align: left !important;\n  }\n  &-right {\n    text-align: right !important;\n  }\n  &-ellipsis {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  &-muted {\n    font: {\n      size: 13px;\n      style: italic;\n    }\n    color: var(--sebrae-gray);\n\n    .blue {\n      color: var(--sebrae-blue-6);\n    }\n  }\n}\n.wrapper-button-fixed {\n  position: sticky;\n  bottom: 0;\n  z-index: 5;\n  width: 100%;\n  padding: 16px;\n  border-radius: 12px 12px 0 0;\n  background: var(--sebrae-white);\n  box-shadow: 0 -2px 6px 0 rgba(0, 0, 0, 0.1);\n  text-align: center;\n\n  p {\n    color: var(--sebrae-black);\n    font-size: 11px;\n    margin-bottom: 8px;\n  }\n  .BaSe--button {\n    span {\n      font-size: 14px;\n    }\n  }\n\n  @media screen and (min-width: 375px) {\n    p {\n      font-size: 13px;\n    }\n    .BaSe--button {\n      span {\n        font-size: 16px;\n      }\n    }\n  }\n  @media screen and (min-width: 768px) {\n    .BaSe--button {\n      max-width: 343px;\n      height: 48px;\n      margin: 0 auto;\n    }\n  }\n}\n.watch-progress-bar {\n  position: relative;\n  width: 100%;\n  margin-top: 50px;\n\n  &__count {\n    position: relative;\n    transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);\n    margin-bottom: 6px;\n    color: var(--sebrae-blue-6);\n    font: {\n      size: 13px;\n      weight: 700;\n    }\n    line-height: 1.2;\n    display: inline-block;\n  }\n  &__bar {\n    border-radius: 4px;\n    background: var(--sebrae-light-gray3);\n    overflow: hidden;\n    width: 100%;\n    height: 24px;\n    margin-bottom: 4px;\n    display: flex;\n    transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);\n\n    &--item {\n      height: 100%;\n      font: {\n        size: 11px;\n        weight: 700;\n      }\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n  }\n  &__limits {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    color: var(--sebrae-light-gray2);\n    font-size: 13px;\n  }\n  &__text {\n    color: var(--sebrae-dark-gray);\n    font-size: 11px;\n    text-align: center;\n    margin-top: 8px;\n    transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);\n  }\n\n  &.invalid {\n    .watch-progress-bar {\n      &__bar {\n        border: 1px solid var(--sebrae-red);\n      }\n      &__text,\n      &__count {\n        color: var(--sebrae-red);\n      }\n    }\n  }\n\n  @media screen and (min-width: 1280px) {\n    &__count,\n    &__limits {\n      font-size: 16px;\n    }\n  }\n}\n.driver-popover {\n  max-width: 354px !important;\n  font-size: 16px !important;\n  border: 2px solid var(--sebrae-light-blue3);\n  border-radius: 4px !important;\n  padding: 16px;\n  background-color: var(--sebrae-white) !important;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n\n  &-title {\n    height: auto;\n    padding-bottom: 14px;\n    background: transparent;\n    font-size: 19px;\n    box-shadow: none;\n    color: var(-sebrae-gray);\n\n    &::after {\n      content: \"\";\n      position: absolute;\n      left: -16px;\n      right: -16px;\n      bottom: 0;\n      height: 1px;\n      background-color: var(--sebrae-light-gray4);\n    }\n  }\n  &-next-btn,\n  &-prev-btn {\n    display: flex;\n    align-items: center !important;\n    justify-content: center !important;\n    font-size: 13px !important;\n    padding: 7px 12px !important;\n    min-height: 32px !important;\n    min-width: 71px !important;\n    border-radius: 4px !important;\n    border: 1px solid var(--sebrae-blue) !important;\n    color: var(--sebrae-blue) !important;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2) !important;\n  }\n  &-prev-btn {\n    padding-right: 11px !important;\n  }\n  &-description {\n    font-size: 16px;\n    font-weight: 400;\n    color: var(--sebrae-gray);\n    margin-top: 20px !important;\n  }\n  &-footer {\n    margin-top: 20px !important;\n  }\n}\n.d-flex {\n  display: flex!important;\n}\n.d-block {\n  display: block!important;\n}\n.d-inline-block {\n  display: inline-block!important;\n}\n.align-items-center {\n  align-items: center!important;\n}\n.justify-content-between {\n  justify-content: space-between!important;\n}\n.quill {\n  position: relative;\n  width: 100%;\n  background-color: #F9F9F9;\n  border-radius: 4px!important;\n\n  &__small-text {\n    color: var(--sebrae-light-gray2);\n    font-size: 11px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 8px;\n\n    &.error {\n      color: var(--sebrae-red);\n    }\n  }\n}\n.ql-toolbar.ql-snow {\n  border: none!important;\n  border-bottom: 1px solid var(--sebrae-light-gray2)!important;\n  display: flex;\n  align-items: center!important;\n  justify-content: space-between!important;\n  padding: 8px 16px!important;\n\n  .ql-formats {\n    margin: 0!important;\n\n    &:first-of-type {\n      flex: 1!important;\n    }\n  }\n}\n.ql-container.ql-snow {\n  border: none!important;\n}\n.ql-editor {\n  font: {\n    family: 'Figtree'!important;\n    size: 16px!important;\n  }\n  -webkit-font-smoothing: antialiased!important;\n  color: var(--sebrae-gray)!important;\n  height: 211px!important;\n  max-height: 211px!important;\n\n  &.ql-blank::before {\n    color: var(--sebrae-light-gray2)!important;\n    font: {\n      family: inherit;\n      weight: 400!important;\n      style: normal!important;\n      size: inherit!important;\n    }\n  }\n  .ql-size-small {\n    font-size: 0.75em!important;\n  }\n  .ql-size-large {\n    font-size: 1.5em!important;\n  }\n  em {\n    font-style: italic!important;\n  }\n  strong {\n    font-size: inherit!important;\n  }\n  * {\n    font: {\n      family: inherit!important;\n    }\n  }\n}\n.ql-snow .ql-picker.ql-size .ql-picker-label::before {\n  content: \"Normal\" !important; /* valor default (false) */\n}\n/* Itens do dropdown */\n.ql-snow .ql-picker.ql-size .ql-picker-item::before {\n  content: \"Normal\" !important; /* default também */\n}\n/* Pequeno */\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=\"small\"]::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=\"small\"]::before {\n  content: \"Pequeno\" !important;\n}\n/* Grande */\n.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=\"large\"]::before,\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=\"large\"]::before {\n  content: \"Grande\" !important;\n}\n\n@keyframes slideOpacityInLeftToRight {\n  from {\n    transform: translateX(-100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0%);\n    opacity: 1;\n  }\n}\n@keyframes slideInLeftToRight {\n  from {\n    transform: translateX(-100%);\n  }\n  to {\n    transform: translateX(0%);\n  }\n}\n@keyframes slideOutRightToLeft {\n  from {\n    transform: translateX(0%);\n  }\n  to {\n    transform: translateX(-100%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
